import Container from './AddDeviationsButton.container';
import AddDeviationsButton from './AddDeviationsButton';

export default Container(AddDeviationsButton);
